import { EmailWritingData } from "~src/redux/typings";

export const INIT_RECIPIENTS: Required<Pick<EmailWritingData, "toAddress">> = {
  toAddress: [],
};
